import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  backTo?: string;
  onBack?: () => void;
  className?: string;
}

export function PageHeader({ title, description, actions, backTo, onBack, className }: PageHeaderProps) {
  const backArrow = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );

  return (
    <div className={twMerge('mb-6', className)}>
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary mb-2"
        >
          {backArrow}
          Back
        </Link>
      )}
      {onBack && !backTo && (
        <button
          onClick={onBack}
          className="inline-flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary mb-2 bg-transparent border-none cursor-pointer p-0"
        >
          {backArrow}
          Back
        </button>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-text-primary tracking-tight">{title}</h1>
          {description && (
            <p className="text-sm text-text-secondary mt-1">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
